import React from 'react';
import userPropicImage from '../../../assets/img/feed-imgs/center/homepost/user-propic1.png';
import userPropicImageTwo from '../../../assets/img/feed-imgs/center/homepost/user-propic2.png';
import postHeart from '../../../assets/img/feed-imgs/center/homepost/icons/post-heart.svg';
import postComment from '../../../assets/img/feed-imgs/center/homepost/icons/post-comment.svg';
import postPlus from '../../../assets/img/feed-imgs/center/homepost/icons/post-plus.svg';
import postShare from '../../../assets/img/feed-imgs/center/homepost/icons/post-share.svg';
import userPostTwo from '../../../assets/img/feed-imgs/center/homepost/user-post2.png'

const EventDetailsPost = () => {
    return (
        <div className="col-12 col-lg-7">
            <div className="card w-auto mb-4 event-details-background">
                <div className="card-body p-0">
                    <div className="row mb-3">
                        <div className="col d-flex gap-3">
                            <img src={userPropicImage} alt='' />
                            <div className="d-grid"><span className="center_txt">Rahim Philip</span><span className="time_txt">5h ago</span></div>
                        </div>
                    </div>
                    <div className="row mb-4">
                        <div className="col"><span className="post_des">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tincidunt non augue ut commodo. Nullam id urna at quam dapibus efficitur. Nunc rhoncus risus quis consectetur sodales. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</span></div>
                    </div>
                    <div className="row">
                        <div className="col-3 d-flex justify-content-center align-items-center gap-2">
                            <img src={postHeart} alt='' />
                            <span className="lc_as">259</span>
                        </div>
                        <div className="col-3 gap-2 d-flex justify-content-center align-items-center">
                            <img src={postComment} alt='' />
                                <span className="lc_as">134</span>
                        </div>
                        <div className="col-3 gap-2 d-flex justify-content-center align-items-center">
                            <img src={postPlus} alt='' />
                                <span className="lc_as">62</span>
                        </div>
                        <div className="col-3 d-flex justify-content-center align-items-center gap-2">
                            <img src={postShare} alt='' /><span className="lc_as">25</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mb-4 event-details-background-and-height"></div>
            <div className="card w-auto mb-4 event-details-background">
                <div className="card-body p-0">
                    <div className="row mb-3">
                        <div className="col d-flex gap-3">
                            <img src={userPropicImageTwo} alt='' />
                            <div className="d-grid">
                                <span className="center_txt">Rahim Philip</span>
                                <span className="time_txt">5h ago</span>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-4">
                        <div className="col"><span className="post_des">Ut tempus posuere eros et congue. Integer blandit lacus sapien, pulvinar venenatis lectus imperdiet in. Vivamus tempor magna a massa commodo, vitae rutrum odio pretium.</span></div>
                    </div>
                    <div className="row mb-4">
                        <div className="col">
                            <img className="w-100" src={userPostTwo} alt='' />

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3 d-flex justify-content-center align-items-center gap-2">
                            <img src={postHeart} alt='' /><span className="lc_as">259</span>
                        </div>
                        <div className="col-3 gap-2 d-flex justify-content-center align-items-center">
                            <img src={postComment} alt='' />
                            <span className="lc_as">134</span>
                        </div>
                        <div className="col-3 gap-2 d-flex justify-content-center align-items-center">
                            <img src={postPlus} alt='' /><span className="lc_as">62</span>
                        </div>
                        <div className="col-3 d-flex justify-content-center align-items-center gap-2">
                            <img src={postShare} alt='' /><span className="lc_as">25</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EventDetailsPost;